var data = [

    {
        name: "illustration1",
        data: [

            { type: "image", src: "/projects/project_01/images/project_01_large_a.jpg" },
            { type: "image", src: "/projects/project_01/images/project_01_large_b.jpg" },
            { type: "image", src: "/projects/project_01/images/project_01_large_c.jpg" },
            { type: "image", src: "/projects/project_01/images/project_01_large_d.jpg" },
            // { type: "image", src: "/projects/project_01/images/project_01_large_e.jpg" },
        ]
    },
    {
        name: "illustration2",
        data: [

            { type: "image", src: "/projects/project_02/images/project_01_large_a.jpg" },
        ]
    },
    {
        name: "illustration3",
        data: [

            { type: "image", src: "/projects/portraits/images/project_01_large_a.jpg" },
            { type: "image", src: "/projects/portraits/images/project_01_large_b.jpg" },
            { type: "image", src: "/projects/portraits/images/project_01_large_c.jpg" },
        ]
    },
    {
        name: "illustration4",
        data: [

            { type: "image", src: "/projects/turnsgray/images/project_01_large_a.jpg" },
        ]
    },
    {
        name: "illustration5",
        data: [

            { type: "image", src: "/projects/natland/images/project_01_large_a.jpg",size:"xmedium" },
            { type: "image", src: "/projects/natland/images/project_01_large_b.jpg",size:"xmedium" },
        ]
    },
    {
        name: "illustration6",
        data: [

            { type: "image", src: "/projects/world/images/project_01_large_a.jpg" },
            { type: "image", src: "/projects/world/images/project_01_large_b.jpg" },
            { type: "image", src: "/projects/world/images/project_01_large_c.jpg" },
            { type: "image", src: "/projects/world/images/project_01_large_d.jpg" },
            { type: "image", src: "/projects/world/images/project_01_large_e.jpg" },
        ]
    },
    {
        name: "illustration7",
        data: [

            { type: "image", src: "/projects/sketches/images/project_01_large_a.jpg" },
            { type: "image", src: "/projects/sketches/images/project_01_large_b.jpg" },
            { type: "image", src: "/projects/sketches/images/project_01_large_c.jpg" },
            { type: "image", src: "/projects/sketches/images/project_01_large_d.jpg" },
            { type: "image", src: "/projects/sketches/images/project_01_large_e.jpg" },
            { type: "image", src: "/projects/sketches/images/project_01_large_f.jpg" },
            { type: "image", src: "/projects/sketches/images/project_01_large_g.jpg" },

        ]
    },
    {
        name: "illustration8",
        data: [

            { type: "image", src: "/projects/converse/images/project_01_large_a.jpg" },
        ]
    },
    {
        name: "graphic1",
        data: [

            { type: "image", src: "/projects/icons/images/project_a.jpg" },
            { type: "image", src: "/projects/icons/images/project_b.jpg" },

        ]
    },
    {
        name: "graphic5",
        data: [

            { type: "image", src: "/projects/openwiregraphic/images/poster2.jpg", size: "medium" },

        ]
    },
    {
        name: "graphic6",
        data: [

            { type: "image", src: "/projects/openwire/images/project_01_large_a.jpg", size: "xmedium" },
            { type: "image", src: "/projects/openwire/images/project_01_large_a.jpg", size: "xmedium" },
            { type: "image", src: "/projects/openwire/images/prototype.jpg", size: "xmedium" },


        ]
    },
    {
        name: "graphic7",
        data: [

            { type: "image", src: "/projects/domeofvisions/images/project_01_large_a.jpg" },


        ]
    },
    {
        name: "graphic8",
        data: [

            { type: "image", src: "/projects/nordic/images/project_01_large_a.png", size: "medium" },
            { type: "image", src: "/projects/nordic/images/project_01_large_b.png", size: "medium" },



        ]
    },
    {
        name: "video1",
        data: [

            { type: "video", src: "https://player.vimeo.com/video/79030504" },



        ]
    },
    {
        name: "video2",
        data: [

            { type: "video", src: "https://player.vimeo.com/video/90638807" },



        ]
    },
    {
        name: "video3",
        data: [

            { type: "video", src: "https://player.vimeo.com/video/105301168" },

        ]
    },
    {
        name: "drawingrobots",
        data: [
            { type: "text", text: "This is a project in the field of Robotics and Art, which has been accomplished by collaboration with an art student from Jutland Art Academy. The aim of this project was to create robots that are able to draw on a table and have a sufficient level of artificial intelligence to avoid falling from the edge. We utilized Arduino boards as the micro-controllers  electronic platform and the programming language C/C++ for the robots' logic. This logic, dedicated to the decision making and the survivability of the robots, is implemented in the form of a finite state machine. In order to create the possibility to modularize the hardware and software aspects of the robots, an input  output library is built. Our robots have done performance in Jutland Art Academy's exhibition and focus-europa in Germany.",
              size: "xmedium" },
            { type: "image", src: "/projects/drawingrobots/images/project_01_large_a.jpg", size: "xmedium" },
            { type: "image", src: "/projects/drawingrobots/images/project_01_large_b.jpg", size: "xmedium" },
            { type: "image", src: "/projects/drawingrobots/images/project_01_large_c.jpg", size: "xmedium" },
            { type: "image", src: "/projects/drawingrobots/images/project_01_large_d.JPG", size: "xmedium" },
            { type: "image", src: "/projects/drawingrobots/images/project_01_large_e.jpg", size: "xmedium" },
            { type: "image", src: "/projects/drawingrobots/images/project_01_large_f.jpg", size: "xmedium" },
            { type: "image", src: "/projects/drawingrobots/images/project_01_large_g.jpg", size: "xmedium" },
            { type: "image", src: "/projects/drawingrobots/images/project_01_large_h.jpg", size: "xmedium" },
            { type: "image", src: "/projects/drawingrobots/images/project_01_large_i.jpg", size: "xmedium" },



        ]
    },
];
export default data;
